import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from '@root/app.state';
import * as RouterActions from '@platform/router.actions';

@Component({
  selector: 'app-button-create-external-user',
  template: `
    <app-link-button
      icon="add_icon"
      [text]="'users.create-user.title' | translate"
      [disabled]="disabled"
      (clicked)="navigateUsersCreate()"
    ></app-link-button>
  `,
  styles: [``],
})
export class ButtonCreateExternalUserComponent {
  @Input() showPermissions?: boolean;
  @Input() disabled!: boolean;
  @Input() customerSpaceId?: string;
  constructor(private store$: Store<RootState>) {}

  navigateUsersCreate() {
    if (this.customerSpaceId) {
      this.store$.dispatch(
        RouterActions.go({
          path: ['/', 'customer-spaces', this.customerSpaceId, 'admin', 'users', 'create'],
          query: {
            showPermissions: this.showPermissions,
          },
        }),
      );
      return;
    }
    console.warn('CustomerSpaceId is undefined.');
  }
}
